export default "__VITE_ASSET__B4X2cTUQ__"